import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AppConfigService} from "@ui-kit/framework/config/app-config.service";
import {UpdatePasswordContextModel} from "@ui-kit/framework/security/model/update-password-context.model";
import {RequestPasswordUpdateOTP} from "@ui-kit/framework/security/model/request-password-update-otp.model";
import {UPDATE_PASSWORD_OTP_TYPE} from "@ui-kit/framework/security/model/update-password-otp-type.enum.model";
import {BaseService} from "@ui-kit/framework/common/base.service";

@Injectable({
  providedIn: 'root'
})
export class OneTimePinService extends BaseService {
  private readonly baseUrl: string;
  private readonly baseUserUrl: string;
  private currentContext: UpdatePasswordContextModel;

  constructor(private http: HttpClient, config: AppConfigService) {
    super();
    const env = config.environment;
    this.baseUrl = env.apiSecurityHost + '/api/user/security/password';
    this.baseUserUrl = env.apiSecurityHost + '/api/user';
    this.clearContext();
    this.currentContext = UpdatePasswordContextModel.getEmptyContext();
  }

  public requestForgotPasswordOTP(otpRequest: RequestPasswordUpdateOTP, retainContext?: boolean): Observable<any> {
    if (!retainContext) {
      this.setOtpRequest(otpRequest);
    }
    if (otpRequest.email) {
      this.currentContext.email = otpRequest.email;
      this.currentContext.updateType = UPDATE_PASSWORD_OTP_TYPE.FORGOT_PASSWORD;
    }
    const uri = this.baseUrl + '/otp/forgot';
    return this.http.post(uri, {email: this.currentContext?.email}, this.options);
  }

  public requestUpdatePasswordOTP(otpRequest: RequestPasswordUpdateOTP, retainContext?: boolean): Observable<any> {
    if (!retainContext) {
      this.setOtpRequest(otpRequest);
    }
    this.currentContext.updateType = UPDATE_PASSWORD_OTP_TYPE.UPDATE_PASSWORD;

    const uri = this.baseUrl + '/otp/update';
    return this.http.post(uri, {userId: this.currentContext?.userId}, this.options);
  }

  public requestNewOTP(retainContext?: boolean): Observable<any> {
    retainContext = retainContext ? true : false;

    switch (this.currentContext!.updateType) {
      case UPDATE_PASSWORD_OTP_TYPE.FORGOT_PASSWORD:
        return this.requestForgotPasswordOTP({email: this.currentContext!.email}, retainContext);
      case UPDATE_PASSWORD_OTP_TYPE.UPDATE_PASSWORD:
        return this.requestUpdatePasswordOTP({userId: this.currentContext!.userId}, retainContext);
      default:
        throw new Error('Unexpected operation');
    }


  }

  public clearContext() {
    this.currentContext = UpdatePasswordContextModel.getEmptyContext();
  }

  public setContext(value: any) {
    this.currentContext = value;
  }

  updateOtp(otp: string): void {
    this.currentContext!.otp = otp;
  }

  public setOtpRequest(value: RequestPasswordUpdateOTP) {
    if (value.email) {
      this.currentContext.email = value.email;
    }
    if (value.userId) {
      this.currentContext.userId = value.userId;
    }
  }

  public requestOtp(id: number): Observable<any> {
    const uri = this.baseUserUrl + '/' + id + '/verify/otp/resend';
    return this.http.post(uri, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    });
  }


}
